<header class="header">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-5 col-md-6">
                <a [attr.href]="url">
                    <img
                        [src]="logo"
                        class="img-fluid logo"
                    />
                </a>
            </div>
            <div class="col-7 col-md-6 header-menu-items">
                <div class="header-cart">
                    <a [routerLink]="['shopping-cart']">
                        <div class="count">
                            {{shoppingCartItemCount$ | async}}
                        </div>
                        <i class="fa fa-shopping-cart"></i>
                    </a>
                </div>

                <div
                    class="signed-in-user"
                    *ngIf="loggedInEmail"
                >
                    <div ngbDropdown>
                        <a ngbDropdownToggle>
                            <i class="fa fa-user"></i>
                            <span
                                class="d-none d-md-inline"
                                [innerHTML]="loggedInEmail"
                            ></span>
                        </a>
                        <div ngbDropdownMenu>
                            <button
                                ngbDropdownItem
                                [routerLink]="['my-account']"
                            >
                                My Account
                            </button>
                            <button
                                ngbDropdownItem
                                (click)="logout()"
                            >
                                Sign Out
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    class="d-none d-md-block account-link"
                    *ngIf="!loggedInEmail && !hideSignIn"
                >
                    <a [routerLink]="['login']">
                        <button
                            type="button"
                            class="btn btn-outline-primary"
                        >Sign in</button>
                    </a>
                </div>

                <div
                    class="d-none d-md-block account-link"
                    *ngIf="!loggedInEmail  && !hideSignUp"
                >
                    <a [routerLink]="['create-account']">
                        <button
                            type="button"
                            class="btn btn-primary"
                        >Sign up</button>
                    </a>
                </div>

                <div
                    class="d-block d-sm-block d-md-none account-link"
                    *ngIf="!loggedInEmail && !hideSignIn"
                >
                    <a [routerLink]="['login']">Sign in</a>
                </div>

                <div
                    class="d-block d-sm-block d-md-none account-link"
                    *ngIf="!loggedInEmail && !hideSignUp"
                >
                    <a [routerLink]="['create-account']">Sign up</a>
                </div>
            </div>
        </div>
    </div>
</header>
